import { IDevice } from '@pages/Assets/Inventory/types';
import { Radio } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import { IDeviceActionRequestPayload } from '../types';
import useUpload from './Upload';

interface IActionFinancial {
  devicesProps: IDevice[] | undefined;
  actionKey: number;
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
}

const useFinancial = ({
  actionKey,
  devicesProps,
  handleDeviceActions,
}: IActionFinancial) => {
  const [extraAction, setextraAction] = useState(actionKey);

  const [uploadedDevices, setUploadedDevices] = useState([]);

  const { t: translate } = useTranslation(['device-actions-modal']);

  const { uploadStep, uploadReinitState } = useUpload({
    actionKey,
    setUploadedDevices,
  });

  const validationStep = useMemo(
    () => ({
      title: translate('steps.validation'),
      content: (
        <div>
          <div className="action-network-reset">
            <Title level={5}>
              {translate('selected-customer', {
                count:
                  (devicesProps && devicesProps.length === 0) || !devicesProps
                    ? uploadedDevices.length
                    : devicesProps.length,
              })}
            </Title>
            <Paragraph>
              {translate('action-confirm-message', {
                actionKey: translate(
                  actionKey === 0 || actionKey === 1
                    ? `device-actions:labels.activation`
                    : `device-actions:labels.${actionKey}`,
                ),
                count:
                  (devicesProps && devicesProps.length === 0) || !devicesProps
                    ? uploadedDevices.length
                    : devicesProps.length,
              })}
            </Paragraph>
          </div>
        </div>
      ),
    }),
    [actionKey, devicesProps, translate, uploadedDevices],
  );

  const steps = [
    {
      title: translate('steps.financial.title'),
      content: (
        <div>
          <Radio.Group
            name="radiogroup"
            defaultValue={31}
            style={{ width: '100%' }}
            value={extraAction}
            onChange={e => {
              setextraAction(e.target.value);
            }}
          >
            <div style={{ marginTop: '10px' }}>
              <Radio value={31}>
                {translate('steps.financial.description')}
              </Radio>
            </div>
            <div
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                display: 'block',
              }}
            >
              <Radio value={32}>
                {translate('steps.financial.description2')}
              </Radio>
            </div>
          </Radio.Group>
        </div>
      ),
    },
  ];
  const contentSteps =
    (devicesProps && devicesProps.length === 0) || !devicesProps
      ? [{ ...uploadStep }, ...steps, { ...validationStep }]
      : [...steps, { ...validationStep }];

  const reinitState = () => {
    uploadReinitState();
    setextraAction(31);
    setUploadedDevices([]);
  };

  const nextStepIsDisabled = useCallback(() => {
    return !(uploadedDevices || devicesProps
      ? uploadedDevices.length > 0 || (devicesProps?.length || 0) > 0
      : false);
  }, [uploadedDevices, devicesProps]);

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = extraAction;

    payload.customerIds =
      devicesProps && devicesProps.length > 0
        ? devicesProps
        : uploadedDevices?.map((device: any) => device.customerId);
    return handleDeviceActions(payload);
  }, [devicesProps, uploadedDevices, handleDeviceActions, extraAction]);

  const financialData = {
    contentSteps,
    onSubmit,
    reinitState,
    nextStepIsDisabled,
  };

  return { financialData };
};

export default useFinancial;
